import React from "react";
import "./Destinations.css";

// Sample data for Indian destinations
const destinations = [
  { id: 1, name: "Taj Mahal", state: "Uttar Pradesh", image: "/assets/taj.jpg", description: "The iconic symbol of love and Mughal architecture in Agra." },
  { id: 2, name: "Jaipur", state: "Rajasthan", image: "/assets/rajasthan.jpg", description: "The Pink City famous for palaces, forts, and rich culture." },
  { id: 3, name: "Kerala Backwaters", state: "Kerala", image: "/assets/kerela.jpg", description: "Peaceful waterways, houseboats, and lush greenery." },
  { id: 4, name: "Goa Beaches", state: "Goa", image: "/assets/goa.jpg", description: "Sun-kissed beaches, vibrant nightlife, and water sports." },
  { id: 5, name: "Varanasi", state: "Uttar Pradesh", image: "/assets/banaras.jpg", description: "Ancient spiritual city on the banks of the Ganges." },
  { id: 6, name: "Leh-Ladakh", state: "Ladakh", image: "/assets/ladakh.jpg", description: "Breathtaking landscapes, mountains, and adventure tourism." },
  { id: 7, name: "Mysore Palace", state: "Karnataka", image: "/assets/mysore.jpg", description: "Historical palace with stunning architecture and royal heritage." },
  { id: 8, name: "Andaman Islands", state: "Andaman & Nicobar", image: "/assets/andaman.jpg", description: "Pristine beaches, scuba diving, and turquoise waters." }
];

const Destinations = () => {
  return (
    <div className="destinations-page">
      
      {/* Video Banner */}
      <div className="video-banner">
        <video src="/assets/videocon.mp4" autoPlay loop muted playsInline className="banner-video"></video>
        <div className="banner-overlay">
          <h1>Discover Incredible India</h1>
          <p>Explore the most beautiful destinations across the country</p>
        </div>
      </div>

      {/* Destinations Grid */}
      <div className="destinations-grid">
        {destinations.map((dest) => (
          <div className="destination-card" key={dest.id}>
            <div className="destination-image">
              <img src={dest.image} alt={dest.name} />
              <div className="destination-overlay">
                <h3>{dest.name}</h3>
                <p>{dest.state}</p>
              </div>
            </div>
            <div className="destination-info">
              <p>{dest.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Destinations;
